<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="title">
            <img :src="haojobLogo" alt="" @click="$router.push('/')" style="cursor:pointer;">
            <ul class="tabItem">
                <li @click="$router.push('/')">首页</li>
                <li @click="$router.push('/investment')">招商加盟</li>
                <li @mouseenter="appDownload"  @mouseleave="leaveDownload" :class="appTrueActive?'active':''">APP下载</li>
                <li @click="$router.push('/relationPages')" :class="!appTrueActive?'active':''">联系我们</li>
                <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
            </ul>
        </div>
        <downloadApp v-if="appTrueActive"></downloadApp>
        <div class="centerFloat">
            <div class="left">
                <p class="wow slideInLeft" data-wow-duration="2s" data-wow-delay="5s">联系我们</p>
                <div class="leftText wow fadeInLeftAnimated" data-wow-duration="10s" data-wow-delay="10s">
                    <span class="wow slideInUp">公司总部</span>
                    <span>公司名称：深圳市猎狼天下网络科技有限公司</span>
                    <span>公司地址：深圳市龙岗区平湖大道华南城5号交易广场A座</span>       
                    <span>客服热线：+86 0755-89359799</span>
                </div>
            </div>
            <img :src="contactus" class="right" alt="">
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'" style="position:relative;bottom:0;"></footerPages>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import contactus from '@/assets/download/contactus-map@2x.png'

export default {
    data(){
        return {
            appTrueActive:false,
            haojobLogo,
            contactus
        }
    },
    mounted () {
        var wow = new WOW(
            {
                boxClass:     'wow',      
                animateClass: 'animated', 
                offset:       0,          
                mobile:       true,      
                live:         true,       
                scrollContainer: null 
            }
            );
            wow.init();
    },
    methods:{
        appDownload(){//移入App下载
            this.appTrueActive=true
        },
        leaveDownload(){
            this.appTrueActive=false
        },
    }
}
</script>
<style scoped lang="less">
    .centerFloat{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 62px;
        padding-bottom: 112px;
        overflow: hidden;
        box-sizing: border-box;
        .left{
            float: left;
            p{
                font-size:36px;
                font-weight:400;
                color:rgba(34,34,34,1);
                line-height:40px;
            }
            .leftText{
                span:first-child{
                    font-size:24px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:36px;
                    margin-top: 40px;
                    margin-bottom: 20px;
                }
                
                span{
                    display: block;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:36px;
                }
            }
        }
        .right{
            width: 600px;
            height: 320px;
            float: right;
            display: block;
        }
    }

</style>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>